import { render, staticRenderFns } from "./index.vue?vue&type=template&id=189127b7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189127b7')) {
      api.createRecord('189127b7', component.options)
    } else {
      api.reload('189127b7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=189127b7", function () {
      api.rerender('189127b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/helpdesk/ticket-flow/index.vue"
export default component.exports